import {
  DialogContent,
  Dialog,
  DialogProps,
  DialogActions,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { styled } from '@mui/styles';
import { PmiButton } from 'shell/components/shared/button';
import { useFormikContext } from 'formik';
import { CommonRequestCertificateInterface } from 'front-office/view-models/common-certificate-form';

export const PmiDialog = styled((props: DialogProps) => <Dialog {...props} />)((props) => ({
  '& .MuiDialog-paper': props.fullScreen
    ? {
        minWidth: 'unset',
        maxWidth: '100%',
      }
    : {
        minWidth: '25rem',
        maxWidth: '30rem',
      },
}));

interface ModalPrintSuccessProps {
  open: boolean;
  onClose: (open: boolean) => void;
  onYes: (
    values: CommonRequestCertificateInterface,
    setFieldValue: (
      key: keyof CommonRequestCertificateInterface,
      value: CommonRequestCertificateInterface[keyof CommonRequestCertificateInterface]
    ) => void
  ) => void;
}

const ModalPrintSuccess = ({
  open,
  onClose,
  onYes,
}: ModalPrintSuccessProps): React.ReactElement => {
  const formContext = useFormikContext<CommonRequestCertificateInterface>();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.md));

  return (
    <PmiDialog
      open={open}
      onClose={() => onClose(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullScreen={fullScreen}
    >
      <DialogContent style={{ padding: '30px 24px' }}>
        La stampa del certificato è stata effettuata correttamente?
      </DialogContent>
      <DialogActions>
        <PmiButton
          variant="contained"
          color="primary"
          type="button"
          onClick={() => onYes(formContext.values, formContext.setFieldValue)}
        >
          SI
        </PmiButton>
        <PmiButton variant="outlined" color="cdmBrand" type="button" onClick={() => onClose(false)}>
          NO
        </PmiButton>
      </DialogActions>
    </PmiDialog>
  );
};

ModalPrintSuccess.displayName = 'Modal request certificate';

export default ModalPrintSuccess;
